import React, { useState, useEffect, useCallback } from 'react';
import { Calendar, Plus, Save, X, Edit, Edit2, Trash2, Eye, EyeOff, ChevronLeft, ChevronRight, ChevronUp, ChevronDown, Printer, UserPlus, UserMinus, Copy, Settings } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { formatarHoras, formatarHorasSemSinal } from '../../utils/formatarHoras';
import { calcularMetricasHorario, ajustarMetricasBackend } from '../../utils/calcularHorarios';
import { SECCOES, TIPOS_DIA, TEMPLATES_TURNOS, CABECALHO_PADRAO, FERIADOS_PT } from '../../constants/horarioConstants';
import HorarioQuickMenu from '../HorarioQuickMenu';
import { getDaysInPeriod, isWeekend, isFeriado, calcularSemanas, calcularDiasUteis, calcularHorasEsperadas, arredondar15min, getDiaSemana, formatarDataExibicao } from '../../utils/horarioUtils';
import api from '../../services/api';
import { getBackendUrl } from '../../utils/config';
import DiaOverridesPanel from '../DiaOverridesPanel';
import axios from 'axios';

const diasSemana = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'];
const diasSemanaKey = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];
const coresColaboradores = [
  'bg-blue-100 border-blue-300', 'bg-green-100 border-green-300',
  'bg-purple-100 border-purple-300', 'bg-orange-100 border-orange-300',
  'bg-pink-100 border-pink-300', 'bg-teal-100 border-teal-300',
  'bg-yellow-100 border-yellow-300', 'bg-red-100 border-red-300',
];

const HorarioVistaAtual = ({
  readOnly,
  isAdmin,
  user,
  // Horários state
  horarios,
  horarioData,
  periodoInicio,
  setPeriodoInicio,
  periodoFim,
  setPeriodoFim,
  colaboradoresHorarios,
  setColaboradoresHorarios,
  cabecalhoEditavel,
  setCabecalhoEditavel,
  isSaving,
  // Modals state
  showModal,
  setShowModal,
  showRelatorioAcessos,
  setShowRelatorioAcessos,
  showHistoricoModal,
  setShowHistoricoModal,
  showModalCabecalho,
  setShowModalCabecalho,
  historicoData,
  setHistoricoData,
  modalTurno,
  setModalTurno,
  viewingHorario,
  setViewingHorario,
  isTrocaModal,
  setIsTrocaModal,
  isTrocaQuickMenu,
  setIsTrocaQuickMenu,
  // Actions from parent
  criarHorarioMensal,
  adicionarColaboradorAoHorario,
  removerColaboradorDoHorario,
  moverColaboradorCima,
  moverColaboradorBaixo,
  // Quick menu
  quickMenuPosition,
  setQuickMenuPosition,
  quickMenuData,
  setQuickMenuData,
  // Derived
  getColaboradoresDisponiveis,
  calcularSemanas: calcularSemanasLocal,
  colaboradoresAtivos,
  formatarDataCurta,
  getSemanasDoMes,
  onHorarioAtualizado,
  // Dialogs
  showCopiarModeloHorarioDialog,
  setShowCopiarModeloHorarioDialog,
  modeloParaCopiar,
  setModeloParaCopiar,
  modelos,
  semanaDestinoIdx,
  setSemanaDestinoIdx,
  aplicarModeloAoHorarioMensal,
  // Handlers from parent
  handleNew,
  handleView,
  handleEdit,
  handleDelete,
  handlePrint,
  handleLimpezaDados,
  handleSave,
  carregarRelatorioAcessos,
  togglePublicacao,
  abrirCopiarModeloHorarioMensal,
  copiarMesAnterior,
  buscarBancoHorasAnterior,
  zerarBancoHoras,
  exportarHistorico,
  visualizarHistorico,
  handleImportarExcel,
  importandoExcel,
  exportarHorarioAtual,
  addTurno,
  calcularHoras,
  carregarCabecalho,
  aplicarTemplate,
  agruparPorSemanasCalendario,
  removerTurno,
  // State from parent
  editingHorario,
  setEditingHorario,
  fileInputRef,
  loading,
  relatorioAcessos,
  loadingHistorico,
  modoExcel,
  lastAutoSave,
  loadingRelatorio,
  semanas,
  horasEsperadas,
  days,
}) => {
  const [diaOverridesAberto, setDiaOverridesAberto] = useState(null);
  const [overridesCount, setOverridesCount] = useState({});

  const API_URL = getBackendUrl();
  const token = localStorage.getItem('token');

  // Carregar contagem de overrides para os dias visiveis
  const carregarOverridesCount = useCallback(async () => {
    if (!days || days.length === 0) return;
    try {
      const res = await axios.get(`${API_URL}/api/alteracoes-dia`, {
        params: { data_inicio: days[0], data_fim: days[days.length - 1] },
        headers: { Authorization: `Bearer ${token}` },
      });
      const contagens = {};
      for (const alt of (res.data || [])) {
        const d = alt.data;
        contagens[d] = (contagens[d] || 0) + 1;
      }
      setOverridesCount(contagens);
    } catch (err) {
      // Silencioso — nao bloquear o horario se a API falhar
    }
  }, [days, API_URL, token]);

  useEffect(() => { carregarOverridesCount(); }, [carregarOverridesCount]);

  return (
    <>
      {/* Painel lateral de overrides */}
      <DiaOverridesPanel
        data={diaOverridesAberto}
        isOpen={!!diaOverridesAberto}
        onClose={() => setDiaOverridesAberto(null)}
        colaboradoresHorarios={colaboradoresHorarios}
        colaboradoresAtivos={colaboradoresAtivos}
        onOverrideSaved={() => carregarOverridesCount()}
      />
          <>
        <Card className="bg-gradient-card border-primary/20">
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="flex items-center gap-2">
              <Calendar className="h-5 w-5" />
              Horários Mensais
              {readOnly && (
                <span className="text-sm font-normal text-muted-foreground ml-2">(Visualização)</span>
              )}
            </CardTitle>
            {isAdmin && (
              <div className="flex gap-2">
                <Button onClick={handleNew} className="bg-primary hover:bg-primary/90">
                  <Plus className="h-4 w-4 mr-2" />
                  Novo Horário
                </Button>
                <Button 
                  onClick={handleLimpezaDados} 
                  variant="outline"
                  className="border-orange-300 text-orange-700 hover:bg-orange-50"
                  title="Diagnosticar e limpar horários vazios"
                >
                  🧹 Manutenção
                </Button>
              </div>
            )}
          </div>
        </CardHeader>
      </Card>

      <div className="grid gap-4">
        {horarios.map(horario => (
          <Card key={horario.id}>
            <CardHeader>
              <div className="flex items-center justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <CardTitle className="text-base">
                      {new Date(horario.periodo_inicio).toLocaleDateString('pt-PT')} - {new Date(horario.periodo_fim).toLocaleDateString('pt-PT')}
                    </CardTitle>
                    {/* Badge de status */}
                    {horario.publicado ? (
                      <span className="px-2 py-0.5 text-xs font-semibold rounded bg-green-100 text-green-700 border border-green-300">
                        ✓ Publicado
                      </span>
                    ) : (
                      <span className="px-2 py-0.5 text-xs font-semibold rounded bg-orange-100 text-orange-700 border border-orange-300">
                        🔒 Rascunho
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-muted-foreground mt-1">
                    {horario.colaboradores_horarios?.length || 0} colaboradores
                    {!horario.publicado && <span className="ml-2 text-orange-600">(Visível apenas para admin)</span>}
                  </p>
                </div>
                <div className="flex gap-2">
                  <Button size="sm" variant="outline" onClick={() => handleView(horario)}>
                    <Eye className="h-4 w-4 mr-2" />
                    Ver
                  </Button>
                  {isAdmin && (
                    <>
                      {/* Botão Relatório de Acessos */}
                      <Button 
                        size="sm" 
                        variant="outline"
                        className="border-purple-500 text-purple-600 hover:bg-purple-50"
                        onClick={() => carregarRelatorioAcessos(horario.id)}
                        title="Ver quem consultou este horário"
                      >
                        👁️ Acessos
                      </Button>
                      {/* Toggle de Publicação */}
                      <Button 
                        size="sm" 
                        variant="outline"
                        className={horario.publicado ? "border-orange-500 text-orange-600 hover:bg-orange-50" : "border-green-500 text-green-600 hover:bg-green-50"}
                        onClick={() => togglePublicacao(horario.id, horario.publicado)}
                        title={horario.publicado ? "Marcar como rascunho" : "Publicar para colaboradores"}
                      >
                        {horario.publicado ? "🔒 Ocultar" : "✓ Publicar"}
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => handleEdit(horario)}>
                        <Edit2 className="h-4 w-4" />
                      </Button>
                      <Button 
                        size="sm" 
                        variant="outline" 
                        className="text-destructive hover:text-destructive"
                        onClick={() => handleDelete(horario.id)}
                      >
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </CardHeader>
          </Card>
        ))}
      </div>

      {/* Modal de edição de horários mensais */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-card rounded-lg w-full max-w-[98vw] max-h-[95vh] flex flex-col">
            {/* CABEÇALHO E BARRA DE AÇÕES - FIXOS NO TOPO */}
            <div className="sticky top-0 bg-card z-20 border-b border-border">
              <div className="p-6 pb-3">
                <h2 className="text-xl font-semibold flex items-center gap-2">
                  <Calendar className="h-5 w-5" />
                  {editingHorario ? 'Editar Horário' : 'Novo Horário'}
                </h2>
              </div>
              
              {/* BARRA DE AÇÕES */}
              <div className="px-6 pb-4 flex justify-between gap-2 border-t border-border pt-4">
                {!readOnly && (
                  <div className="flex gap-2 flex-wrap">
                    <Button 
                      variant="outline" 
                      onClick={abrirCopiarModeloHorarioMensal}
                      className="border-purple-500 text-purple-600 hover:bg-purple-50"
                    >
                      <Copy className="h-4 w-4 mr-1" /> Copiar de Modelo
                    </Button>
                    <Button 
                      variant="outline" 
                      onClick={copiarMesAnterior}
                      className="border-blue-500 text-blue-600 hover:bg-blue-50"
                    >
                      📋 Copiar Mês Anterior
                    </Button>
                    <Button 
                      variant="outline" 
                      onClick={buscarBancoHorasAnterior}
                      className="border-green-500 text-green-600 hover:bg-green-50"
                    >
                      📥 Buscar Banco H Anterior
                    </Button>
                    <Button 
                      variant="outline" 
                      onClick={zerarBancoHoras}
                      className="border-red-500 text-red-600 hover:bg-red-50"
                    >
                      🔄 Zerar Banco
                    </Button>
                    {/* Botão para importar Excel */}
                    <input
                      type="file"
                      ref={fileInputRef}
                      accept=".xlsx,.xls"
                      onChange={handleImportarExcel}
                      style={{ display: 'none' }}
                    />
                    <Button 
                      variant="outline" 
                      onClick={() => fileInputRef.current?.click()}
                      disabled={importandoExcel}
                      className="border-orange-500 text-orange-600 hover:bg-orange-50"
                    >
                      {importandoExcel ? '⏳ A importar...' : '📥 Importar Excel'}
                    </Button>
                    {typeof exportarHorarioAtual === 'function' && (
                      <Button
                        variant="outline"
                        onClick={exportarHorarioAtual}
                        className="border-blue-500 text-blue-600 hover:bg-blue-50"
                        data-testid="btn-exportar-excel"
                      >
                        📤 Exportar Excel
                      </Button>
                    )}
                  </div>
                )}
                <div className="flex gap-2">
                  {readOnly && viewingHorario && (
                    <Button 
                      variant="outline"
                      onClick={async () => {
                        if (!window.confirm('🔄 Recalcular banco de horas deste horário?\n\nIsso irá aplicar as regras corretas de cálculo.\n\nTem certeza?')) {
                          return;
                        }
                        
                        try {
                          const token = localStorage.getItem('token');
                          await api.put(
                            `${getBackendUrl()}/api/horarios-mensais/${viewingHorario.id}`,
                            viewingHorario,
                            { headers: { Authorization: `Bearer ${token}` } }
                          );
                          
                          alert('✅ Banco de horas recalculado com sucesso!');
                          
                          // Recarregar o horário
                          const response = await api.get(
                            `${getBackendUrl()}/api/horarios-mensais/${viewingHorario.id}`,
                            { headers: { Authorization: `Bearer ${token}` } }
                          );
                          setViewingHorario(response.data);
                        } catch (err) {
                          console.error('Erro ao recalcular:', err);
                          alert('❌ Erro ao recalcular horário');
                        }
                      }}
                      className="border-orange-500 text-orange-600 hover:bg-orange-50"
                    >
                      🔄 Recalcular Banco
                    </Button>
                  )}
                  <Button variant="outline" onClick={async () => {
                    // Salvar automaticamente antes de fechar (só se houver dados reais)
                    const temDadosReais = colaboradoresHorarios.some(c => {
                      const registos = c.registos_por_dia || {};
                      return Object.keys(registos).length > 0;
                    });
                    
                    if (temDadosReais) {
                      console.log('[FECHAR] Salvando automaticamente antes de fechar...');
                      try {
                        await handleSave(true, true); // auto-save silencioso
                        console.log('[FECHAR] ✅ Dados salvos antes de fechar');
                      } catch (err) {
                        console.error('[FECHAR] Erro ao salvar:', err);
                      }
                    } else {
                      console.log('[FECHAR] Sem dados para salvar. Fechando sem salvar.');
                    }
                    setShowModal(false);
                  }}>
                    <X className="h-4 w-4 mr-2" />
                    {readOnly ? 'Fechar' : 'Cancelar'}
                  </Button>
                  {!readOnly && (
                    <div className="flex items-center gap-2">
                      {lastAutoSave && (
                        <span className="text-xs text-muted-foreground">
                          💾 Auto-save: {new Date(lastAutoSave).toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' })}
                        </span>
                      )}
                      <Button 
                        disabled={isSaving}
                        onClick={async () => {
                          // 🔒 Verificar se há dados para salvar
                          const temDadosReais = colaboradoresHorarios.some(c => {
                            const registos = c.registos_por_dia || {};
                            const totalDias = Object.keys(registos).filter(dia => {
                              const turnos = registos[dia] || [];
                              return turnos.length > 0;
                            }).length;
                            return totalDias > 0;
                          });
                          
                          if (!temDadosReais) {
                            alert('⚠️ Não há dados para salvar. Por favor, adicione turnos aos colaboradores antes de salvar.');
                            return;
                          }
                          
                          await handleSave(false, false);
                        }} 
                        className="bg-success hover:bg-success/90"
                      >
                        {isSaving ? (
                          <>
                            <span className="animate-spin mr-2">⏳</span>
                            A guardar...
                          </>
                        ) : (
                          <>
                            <Save className="h-4 w-4 mr-2" />
                            Salvar
                          </>
                        )}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* CONTEÚDO COM SCROLL */}
            <div className="flex-1 overflow-y-auto p-6 space-y-6">
              <Card>
                <CardHeader>
                  <CardTitle className="text-base">MOTIVOS À JUSTA, Lda</CardTitle>
                </CardHeader>
                <CardContent className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium mb-2">Período Início</label>
                    <input
                      type="date"
                      value={periodoInicio}
                      onChange={(e) => setPeriodoInicio(e.target.value)}
                      className="w-full px-3 py-2 border rounded-md bg-background"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-2">Período Fim</label>
                    <input
                      type="date"
                      value={periodoFim}
                      onChange={(e) => setPeriodoFim(e.target.value)}
                      className="w-full px-3 py-2 border rounded-md bg-background"
                    />
                  </div>
                </CardContent>
              </Card>

              {periodoInicio && periodoFim && (
                <Card className="bg-blue-50 border-blue-200">
                  <CardContent className="pt-6">
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-sm">
                      <div>
                        <div className="text-muted-foreground">Semanas</div>
                        <div className="text-xl font-bold text-primary">{semanas.toFixed(1)} semanas</div>
                      </div>
                      <div>
                        <div className="text-muted-foreground">Horas Esperadas</div>
                        <div className="text-xl font-bold text-primary">{Math.round(horasEsperadas)}h</div>
                      </div>
                      <div>
                        <div className="text-muted-foreground">Banco Ant. GLOBAL</div>
                        <div className="text-xl font-bold text-orange-600">
                          {(() => {
                            const totalBancoAnt = colaboradoresHorarios.reduce((sum, c) => sum + (c.banco_horas_anterior || 0), 0);
                            // Preservar minutos na exibição
                            return formatarHoras(totalBancoAnt.toFixed(2));
                          })()}
                        </div>
                      </div>
                      <div className="col-span-2 text-xs text-muted-foreground">
                        <strong>✅ Automático:</strong>
                        <div>• Banco anterior carrega automaticamente</div>
                        <div>• Feriados: hora trabalhada = {(() => {
                          const ano = days.length > 0 ? new Date(days[0] + 'T00:00:00').getFullYear() : new Date().getFullYear();
                          return '1h (hora normal)';
                        })()}</div>
                        <div>• Férias/Baixas: cada dia = 8h</div>
                        <div>• Reuniões: cada uma = 1h</div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* Secção para adicionar colaboradores */}
              {periodoInicio && periodoFim && !readOnly && getColaboradoresDisponiveis().length > 0 && (
                <Card className="bg-green-50 border-green-200">
                  <CardContent className="pt-4 pb-4">
                    <div className="flex items-center gap-4 flex-wrap">
                      <div className="flex items-center gap-2">
                        <UserPlus className="h-5 w-5 text-green-600" />
                        <span className="font-medium text-green-800">Adicionar Colaborador:</span>
                      </div>
                      <select
                        className="flex-1 min-w-[200px] px-3 py-2 border border-green-300 rounded-md bg-white text-sm"
                        onChange={(e) => {
                          if (e.target.value) {
                            adicionarColaboradorAoHorario(e.target.value);
                            e.target.value = '';
                          }
                        }}
                        defaultValue=""
                      >
                        <option value="">-- Selecione um colaborador --</option>
                        {getColaboradoresDisponiveis().map(c => (
                          <option key={c.id} value={c.id}>
                            {c.nome} ({c.loja || 'Sem loja'})
                          </option>
                        ))}
                      </select>
                      <div className="text-xs text-green-600">
                        {getColaboradoresDisponiveis().length} colaborador(es) disponível(is)
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* PAINEL DE RESUMO DE TOTAIS */}
              {days.length > 0 && colaboradoresHorarios.length > 0 && (
                <Card className="bg-gradient-to-r from-blue-50 to-green-50 border-2 border-blue-300">
                  <CardHeader>
                    <CardTitle className="text-base text-blue-800 flex items-center gap-2">
                      📊 Resumo de Totais - Todos os Colaboradores
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
                      {colaboradoresHorarios.map((colab, idx) => {
                        // RESUMO DE TOTAIS: Usar função CENTRALIZADA para garantir consistência
                        // Passar ano de referência para cálculo correto do multiplicador de feriados
                        const anoRef = periodoInicio ? new Date(periodoInicio + 'T00:00:00').getFullYear() : new Date().getFullYear();
                        const metricas = calcularMetricasHorario(colab, semanas, null, anoRef);
                        
                        // Extrair valores da função centralizada
                        const {
                          totalHoras,
                          totalHorasNormais,
                          totalHorasFeriado: totalFeriado,
                          totalHorasReunioes: totalReunioes,
                          totalHorasFerias,
                          totalHorasGestao,
                          totalHorasBaixa,
                          diasFerias,
                          diasFalta,
                          diasFolga,
                          diasFolgaComp,
                          diasBaixa,
                          diasGestao,
                          bancoAnterior,
                          bancoTotal: bancoAtual
                        } = metricas;
                        
                        return (
                          <div key={colab.colaborador_id} className="bg-white p-2 rounded border border-gray-300 shadow-sm">
                            <div className="font-bold text-xs text-gray-800 mb-1 flex items-center justify-between gap-1">
                              <span className="truncate" title={colab.colaborador_nome}>
                                {colab.colaborador_nome}
                              </span>
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  visualizarHistorico(colab);
                                }}
                                className="text-blue-500 hover:text-blue-700 hover:bg-blue-50 rounded p-0.5 flex-shrink-0"
                                title="Ver histórico de Banco de Horas"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                  <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
                                </svg>
                              </button>
                            </div>
                            <div className="space-y-0.5 text-[10px]">
                              {/* BREAKDOWN DETALHADO - Sempre mostrar na ordem: Normais, Feriados, Férias, Reuniões, Gestão, Baixa */}
                              
                              {/* Horas Normais */}
                              <div className="flex justify-between">
                                <span className="text-gray-600">🕐 Normais:</span>
                                <span className="font-semibold text-gray-700">{formatarHoras(totalHorasNormais.toFixed(2))}</span>
                              </div>
                              
                              {/* Feriados (mostrar sempre se > 0) */}
                              {totalFeriado > 0 && (
                                <div className="flex justify-between">
                                  <span className="text-gray-600">🎉 Feriado:</span>
                                  <span className="font-semibold text-purple-600">{formatarHoras(totalFeriado.toFixed(2))}</span>
                                </div>
                              )}
                              
                              {/* Férias */}
                              {diasFerias > 0 && (
                                <div className="flex justify-between">
                                  <span className="text-gray-600">✈️ Férias:</span>
                                  <span className="font-semibold text-green-600">{diasFerias}d ({formatarHoras(totalHorasFerias.toFixed(2))})</span>
                                </div>
                              )}
                              
                              {/* Reuniões */}
                              {totalReunioes > 0 && (
                                <div className="flex justify-between">
                                  <span className="text-gray-600">📋 Reuniões:</span>
                                  <span className="font-semibold text-blue-500">{formatarHoras(totalReunioes.toFixed(2))}</span>
                                </div>
                              )}
                              
                              {/* Gestão */}
                              {diasGestao > 0 && (
                                <div className="flex justify-between">
                                  <span className="text-gray-600">📊 Gestão:</span>
                                  <span className="font-semibold text-indigo-600">{diasGestao}d ({formatarHoras(totalHorasGestao.toFixed(2))})</span>
                                </div>
                              )}
                              
                              {/* Baixa */}
                              {diasBaixa > 0 && (
                                <div className="flex justify-between">
                                  <span className="text-gray-600">🏥 Baixa:</span>
                                  <span className="font-semibold text-red-500">{diasBaixa}d ({formatarHoras(totalHorasBaixa.toFixed(2))})</span>
                                </div>
                              )}
                              
                              {/* TOTAL H - Destaque */}
                              <div className="flex justify-between border-t border-gray-300 pt-1 mt-1 bg-blue-50 -mx-1 px-1 rounded">
                                <span className="text-gray-800 font-bold">Total H:</span>
                                <span className="font-bold text-blue-700">{formatarHoras(totalHoras.toFixed(2))}</span>
                              </div>
                              
                              {/* Banco Anterior */}
                              <div className="flex justify-between items-center pt-1">
                                <span className="text-gray-600">Banco Ant:</span>
                                {!readOnly ? (
                                  <input
                                    key={`banco-ant-${colab.colaborador_id}-${bancoAnterior}`}
                                    type="text"
                                    className="w-20 px-2 py-1 text-sm border rounded text-right"
                                    defaultValue={(() => {
                                      // Formato: 64h30m (horas e minutos)
                                      const totalHoras = Math.abs(bancoAnterior);
                                      const horas = Math.floor(totalHoras);
                                      const minutos = Math.round((totalHoras - horas) * 60);
                                      const sinal = bancoAnterior < 0 ? '-' : '';
                                      
                                      if (minutos > 0) {
                                        return `${sinal}${horas}h${minutos}m`;
                                      }
                                      return `${sinal}${horas}h`;
                                    })()}
                                    onBlur={(e) => {
                                      const valor = e.target.value.trim();
                                      let novoValor = null;
                                      
                                      // Parser: aceita -55h30m, -55h, -55
                                      let match = valor.match(/^(-?)(\d+)h(\d+)m?$/);
                                      if (match) {
                                        const sinal = match[1] === '-' ? -1 : 1;
                                        const horas = parseInt(match[2]) || 0;
                                        const minutos = parseInt(match[3]) || 0;
                                        novoValor = sinal * (horas + minutos / 60);
                                      }
                                      
                                      if (!novoValor && (match = valor.match(/^(-?)(\d+)h$/))) {
                                        const sinal = match[1] === '-' ? -1 : 1;
                                        const horas = parseInt(match[2]) || 0;
                                        novoValor = sinal * horas;
                                      }
                                      
                                      if (novoValor === null && (match = valor.match(/^(-?\d+)$/))) {
                                        novoValor = parseFloat(match[1]);
                                      }
                                      
                                      if (novoValor !== null) {
                                        // NÃO ARREDONDAR - Manter o valor EXATO que o usuário digitou
                                        setColaboradoresHorarios(prev => prev.map(c =>
                                          c.colaborador_id === colab.colaborador_id
                                            ? { ...c, banco_horas_anterior: novoValor, banco_horas_anterior_manual: true }
                                            : c
                                        ));
                                        
                                        // Mostrar o valor formatado com horas e minutos (se houver)
                                        const horasAbs = Math.floor(Math.abs(novoValor));
                                        const minutosAbs = Math.round((Math.abs(novoValor) % 1) * 60);
                                        const sinalFinal = novoValor < 0 ? '-' : '';
                                        e.target.value = minutosAbs > 0 ? `${sinalFinal}${horasAbs}h${minutosAbs}m` : `${sinalFinal}${horasAbs}h`;
                                      } else {
                                        e.target.style.borderColor = 'red';
                                        e.target.style.backgroundColor = '#fee';
                                        setTimeout(() => {
                                          e.target.style.borderColor = '';
                                          e.target.style.backgroundColor = '';
                                        }, 1500);
                                      }
                                    }}
                                    title="✏️ EDITÁVEL: Digite -5h, -8h30m, etc"
                                    placeholder="0h"
                                  />
                                ) : (
                                  <span className="font-semibold text-orange-600">{formatarHoras(bancoAnterior.toFixed(2))}</span>
                                )}
                              </div>
                              <div className="flex justify-between border-t border-gray-200 pt-0.5">
                                <span className="text-gray-700 font-medium">Banco H:</span>
                                <span className={`font-bold ${bancoAtual >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                  {formatarHoras(bancoAtual.toFixed(2))}
                                </span>
                              </div>
                              {(diasFerias > 0 || diasFalta > 0 || diasFolga > 0) && (
                                <div className="text-[9px] text-gray-500 pt-0.5">
                                  {diasFerias > 0 && `✈️${diasFerias} `}
                                  {diasFalta > 0 && `❌${diasFalta} `}
                                  {diasFolga > 0 && `⚠️${diasFolga}${diasFolgaComp > 0 ? `(${diasFolgaComp}FC)` : ''}`}
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* MODO EXCEL - Visualização por SEMANAS Empilhadas Verticalmente */}
              {days.length > 0 && (
                <Card>
                  <CardHeader className="bg-gradient-to-r from-green-50 to-blue-50">
                    <CardTitle className="text-lg text-green-700">📊 Modo Excel - Vista por Semanas</CardTitle>
                  </CardHeader>
                  <CardContent className="pt-6 space-y-8">
                    {(() => {
                      // Usar função helper para agrupar por semanas de calendário
                      const semanas = agruparPorSemanasCalendario(days);
                      
                      return semanas.map((semana, semanaIdx) => {
                        const primeiraData = new Date(semana[0] + 'T00:00:00');
                        const ultimaData = new Date(semana[semana.length - 1] + 'T00:00:00');
                        const numSemanaDoAno = Math.ceil((primeiraData.getDate() + primeiraData.getDay()) / 7);
                        
                        return (
                          <div key={`semana-${semanaIdx}`} className="mb-8">
                            {/* TÍTULO DA SEMANA */}
                            <div className="bg-blue-200 border-2 border-blue-400 p-3 mb-2 rounded">
                              <h3 className="text-lg font-bold text-center">
                                SEMANA {numSemanaDoAno} ({primeiraData.toLocaleDateString('pt-PT')} - {ultimaData.toLocaleDateString('pt-PT')})
                              </h3>
                            </div>
                            
                            {/* TABELA DA SEMANA */}
                            <div className="overflow-x-auto">
                              <table className="border-collapse text-[9px]" style={{minWidth: '1600px', width: 'auto'}}>
                                <thead>
                                  {/* LINHA 1: DIA DA SEMANA + NÚMERO */}
                                  <tr>
                                    <th rowSpan="2" className="border border-black p-1 bg-gray-300 w-[100px] font-bold text-[9px] sticky left-0 z-10">
                                      Colaborador
                                    </th>
                                    {semana.map((dia, diaIdx) => {
                                      const date = new Date(dia + 'T00:00:00');
                                      const diaSemana = ['DOMINGO', 'SEGUNDA', 'TERÇA', 'QUARTA', 'QUINTA', 'SEXTA', 'SÁBADO'][date.getDay()];
                                      const numeroDia = date.getDate();
                                      const ehFeriado = isFeriado(dia);
                                      const isDomingo = date.getDay() === 0;
                                      
                                      return (
                                        <th 
                                          key={`dia-${diaIdx}`} 
                                          colSpan="3" 
                                          className={`border border-black p-0.5 font-bold text-center text-[8px] cursor-pointer hover:ring-2 hover:ring-primary/50 transition-all relative ${
                                            ehFeriado ? 'bg-red-200' : isDomingo ? 'bg-red-100' : 'bg-gray-100'
                                          }`}
                                          onClick={() => setDiaOverridesAberto(dia)}
                                          title={`Clique para gerir excepcoes de ${diaSemana} ${numeroDia}`}
                                          data-testid={`dia-header-${dia}`}
                                        >
                                          {diaSemana}<br/>{numeroDia}{ehFeriado && ' *'}
                                          {overridesCount[dia] > 0 && (
                                            <span className="absolute -top-1 -right-1 bg-amber-500 text-white text-[7px] font-bold rounded-full w-3.5 h-3.5 flex items-center justify-center" data-testid={`dia-override-badge-${dia}`}>
                                              {overridesCount[dia]}
                                            </span>
                                          )}
                                        </th>
                                      );
                                    })}
                                  </tr>
                                  
                                  {/* LINHA 2: SECÇÕES (Café, Loja, Sátão) + COLUNAS DE TOTAIS */}
                                  <tr>
                                    {semana.map((dia, diaIdx) => (
                                      <React.Fragment key={`seccoes-${diaIdx}`}>
                                        <th className="border border-black p-1 bg-orange-100 text-[8px] font-semibold w-[120px]">
                                          Café
                                        </th>
                                        <th className="border border-black p-1 bg-blue-100 text-[8px] font-semibold w-[120px]">
                                          Loja
                                        </th>
                                        <th className="border border-black p-1 bg-green-100 text-[8px] font-semibold w-[120px]">
                                          Sátão
                                        </th>
                                      </React.Fragment>
                                    ))}
                                    {/* COLUNA DE TOTAL */}
                                    <th className="border border-black p-1 bg-blue-200 text-[8px] font-bold w-[100px]" rowSpan="1">
                                      Total H
                                    </th>
                                  </tr>
                                </thead>
                                
                                {/* CORPO DA TABELA - COLABORADORES */}
                                <tbody>
                                  {colaboradoresHorarios.map((colab, colabIdx) => (
                                    <tr key={colabIdx} className={colabIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                      {/* NOME DO COLABORADOR - STICKY à esquerda */}
                                      <td className="border border-black p-1 font-bold text-[9px] sticky left-0 z-10" style={{backgroundColor: colabIdx % 2 === 0 ? '#f3f4f6' : '#e5e7eb'}}>
                                        <div className="flex items-center justify-between gap-1">
                                          <span className="flex-1">{colab.colaborador_nome}</span>
                                          {!readOnly && (
                                            <div className="flex items-center gap-1">
                                              <div className="flex flex-col gap-0.5">
                                                <button
                                                  onClick={() => moverColaboradorCima(colab.colaborador_id, colab.seccao)}
                                                  className="p-0.5 hover:bg-blue-100 rounded text-gray-500 hover:text-blue-600 transition-colors"
                                                  title="Mover para cima"
                                                >
                                                  <ChevronUp className="h-3 w-3" />
                                                </button>
                                                <button
                                                  onClick={() => moverColaboradorBaixo(colab.colaborador_id, colab.seccao)}
                                                  className="p-0.5 hover:bg-blue-100 rounded text-gray-500 hover:text-blue-600 transition-colors"
                                                  title="Mover para baixo"
                                                >
                                                  <ChevronDown className="h-3 w-3" />
                                                </button>
                                              </div>
                                              <button
                                                onClick={() => removerColaboradorDoHorario(colab.colaborador_id)}
                                                className="p-1 hover:bg-red-100 rounded text-red-500 hover:text-red-700 transition-colors"
                                                title="Remover colaborador deste horário"
                                              >
                                                <UserMinus className="h-3.5 w-3.5" />
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                      
                                      {/* DIAS DA SEMANA - 3 COLUNAS POR DIA (Café, Loja, Sátão) */}
                                      {semana.map((dia, diaIdx) => {
                                        const turnos = colab.registos_por_dia?.[dia] || [];
                                        const ehFeriado = isFeriado(dia);
                                        const isDomingo = new Date(dia + 'T00:00:00').getDay() === 0;
                                        
                                        // Agrupar turnos por secção
                                        const turnosCafe = turnos.filter(t => t.local === 'Café');
                                        const turnosAvelal = turnos.filter(t => t.local === 'Loja Avelal');
                                        const turnosSatao = turnos.filter(t => t.local === 'Loja Sátão');
                                        
                                        // Função para determinar cor de fundo
                                        const getCorFundo = (turnosArr) => {
                                          if (turnosArr.length === 0) return '';
                                          const turno = turnosArr[0];
                                          if (turno.tipo === 'folga') return 'bg-yellow-300';
                                          if (turno.tipo === 'folga_compensacao') return 'bg-yellow-300';
                                          if (turno.tipo === 'ferias') return 'bg-green-200';
                                          if (turno.tipo === 'falta') return 'bg-red-200';
                                          if (turno.tipo === 'baixa') return 'bg-yellow-100';
                                          if (turno.tipo === 'reuniao') return 'bg-purple-200';
                                          if (turno.tipo === 'gestao') return 'bg-orange-200';
                                          if (turno.tipo === 'apoio') return 'bg-indigo-100';
                                          if (turno.tipo === 'integracao') return 'bg-teal-100';
                                          return '';
                                        };
                                        
                                        // Função para renderizar célula editável tipo Excel - UM campo por célula
                                        const renderCelulaEditavel = (turnosArr, seccao) => {
                                          const bgBase = ehFeriado ? 'bg-red-50' : isDomingo ? 'bg-red-50' : '';
                                          const corFundo = getCorFundo(turnosArr) || bgBase;
                                          
                                          // Concatenar TODOS os horários/tipos desta secção - VERTICAL (uma linha por turno)
                                          const horariosStr = turnosArr
                                            .map(t => {
                                              // APOIO/REUNIÃO/INTEGRAÇÃO/GESTÃO: mostrar tipo + horas (se houver entrada/saída)
                                              const PREFIXO_TIPO_MANUAL = {
                                                'apoio': 'APOIO',
                                                'reuniao': 'REUNIÃO',
                                                'integracao': 'INTEGRAÇÃO',
                                                'gestao': 'GESTÃO',
                                              };
                                              if (PREFIXO_TIPO_MANUAL[t.tipo]) {
                                                if (t.entrada && t.saida) {
                                                  return `${PREFIXO_TIPO_MANUAL[t.tipo]} ${t.entrada}-${t.saida}`;
                                                }
                                                return PREFIXO_TIPO_MANUAL[t.tipo];
                                              }
                                              // Turnos NORMAIS: mostrar 🔄 se e_troca
                                              if (t.tipo === 'normal' && t.entrada && t.saida) {
                                                return t.e_troca ? `${t.entrada}-${t.saida} 🔄` : `${t.entrada}-${t.saida}`;
                                              }
                                              // Turnos especiais sem horário: mostrar apenas o tipo
                                              const tipoLabels = {
                                                'folga': '⚠️ FOLGA',
                                                'folga_compensacao': '⚠️ FOLGA C.',
                                                'ferias': '🏖️ FÉRIAS',
                                                'falta': '❌ FALTA',
                                                'baixa': '🏥 BAIXA',
                                                'troca': '🔄 TROCA'
                                              };
                                              return tipoLabels[t.tipo] || (t.entrada && t.saida ? `${t.entrada}-${t.saida}` : '');
                                            })
                                            .filter(s => s)
                                            .join('\n');  // QUEBRA DE LINHA em vez de vírgula
                                          
                                          // Célula tipo Excel - TEXTAREA para múltiplas linhas VERTICAIS
                                          return (
                                            <td 
                                              className={`border border-black p-0.5 text-center relative group ${corFundo}`}
                                              style={{minHeight: '40px', minWidth: '120px', maxWidth: '160px', width: '120px'}}
                                            >
                                              <div className="relative w-full h-full flex items-center justify-center">
                                                <textarea
                                                  key={`${colab.colaborador_id}-${dia}-${seccao}`}
                                                  data-colab={colab.colaborador_id}
                                                  data-dia={dia}
                                                  data-seccao={seccao}
                                                  defaultValue={horariosStr}
                                                  className={`w-full px-0.5 py-0.5 text-center bg-transparent border-none focus:outline-none focus:ring-0 cursor-text resize-none overflow-hidden ${
                                                    horariosStr.includes('FOLGA') || horariosStr.includes('FÉRIAS') || horariosStr.includes('FALTA') || horariosStr.includes('BAIXA') 
                                                      ? 'text-[11px] font-bold' 
                                                      : 'text-[9px] font-semibold'
                                                  }`}
                                                  placeholder="-"
                                                  rows={Math.max(1, turnosArr.length)}
                                                  style={{minHeight: '38px', lineHeight: '1.3'}}
                                                  onBlur={(e) => {
                                                  const valor = e.target.value.trim();
                                                  
                                                  if (valor === '') {
                                                    // Remover todos os turnos desta secção neste dia
                                                    const todosOsTurnos = colab.registos_por_dia?.[dia] || [];
                                                    const indicesParaRemover = [];
                                                    todosOsTurnos.forEach((t, idx) => {
                                                      if (t.local === seccao) {
                                                        indicesParaRemover.push(idx);
                                                      }
                                                    });
                                                    for (let i = indicesParaRemover.length - 1; i >= 0; i--) {
                                                      removerTurno(colab.colaborador_id, dia, indicesParaRemover[i]);
                                                    }
                                                    e.target.value = '';
                                                    return;
                                                  }
                                                  
                                                  // SUPORTA MÚLTIPLOS TURNOS separados por QUEBRA DE LINHA ou vírgula
                                                  // Ex: "7-12\n13-20" ou "7-12, 13-20" ou "9h-13h, 14h-18h"
                                                  const partes = valor.split(/[\n,]/).map(p => p.trim()).filter(p => p);
                                                  // Regex melhorado para suportar: 7h30m, 13h15m, 9h, 9:30, 9-17, etc.
                                                  const regex = /(\d{1,2})(?:[:h](\d{0,2}))?(?:m)?\s*[-–]\s*(\d{1,2})(?:[:h](\d{0,2}))?(?:m)?/;
                                                  
                                                  const turnosNovos = [];
                                                  partes.forEach(parte => {
                                                    // Detectar tipo manual por prefixo (APOIO/REUNIÃO/INTEGRAÇÃO/GESTÃO)
                                                    const parteUpper = parte.toUpperCase();
                                                    let tipoDetectado = 'normal';
                                                    let parteHorario = parte;
                                                    if (parteUpper.startsWith('APOIO')) {
                                                      tipoDetectado = 'apoio';
                                                      parteHorario = parte.substring(5).trim();
                                                    } else if (parteUpper.startsWith('REUNIÃO') || parteUpper.startsWith('REUNIAO')) {
                                                      tipoDetectado = 'reuniao';
                                                      parteHorario = parte.replace(/^(REUNIÃO|REUNIAO|reunião|reuniao)/i, '').trim();
                                                    } else if (parteUpper.startsWith('INTEGRAÇÃO') || parteUpper.startsWith('INTEGRACAO')) {
                                                      tipoDetectado = 'integracao';
                                                      parteHorario = parte.replace(/^(INTEGRAÇÃO|INTEGRACAO|integração|integracao)/i, '').trim();
                                                    } else if (parteUpper.startsWith('GESTÃO') || parteUpper.startsWith('GESTAO')) {
                                                      tipoDetectado = 'gestao';
                                                      parteHorario = parte.replace(/^(GESTÃO|GESTAO|gestão|gestao)/i, '').trim();
                                                    }

                                                    const match = parteHorario.match(regex);
                                                    if (!match && tipoDetectado !== 'normal' && !parteHorario) {
                                                      // Só o rótulo (ex: "GESTÃO") → turno sem horas (Gestão = dia inteiro 8h)
                                                      turnosNovos.push({ entrada: null, saida: null, tipo: tipoDetectado, semHoras: true });
                                                    } else if (match) {
                                                      const [_, h1, m1, h2, m2] = match;
                                                      const entrada = `${h1.padStart(2, '0')}:${(m1 || '00').padStart(2, '0')}`;
                                                      const saida = `${h2.padStart(2, '0')}:${(m2 || '00').padStart(2, '0')}`;
                                                      turnosNovos.push({ entrada, saida, tipo: tipoDetectado });
                                                    }
                                                  });
                                                  
                                                  if (turnosNovos.length > 0) {
                                                    // Substituir APENAS os turnos NORMAIS desta secção, mantendo folgas/férias/etc
                                                    setColaboradoresHorarios(prev => prev.map(c => {
                                                      if (c.colaborador_id === colab.colaborador_id) {
                                                        const todosOsTurnos = c.registos_por_dia?.[dia] || [];
                                                        
                                                        // Manter turnos especiais (folga, férias, gestão, etc.) e de outras secções
                                                        // MAS remover apoio/reuniao/integracao e normal/troca desta secção (serão substituídos)
                                                        const TIPOS_SUBST = ['normal', 'troca', 'apoio', 'reuniao', 'integracao', 'gestao'];
                                                        const turnosParaManter = todosOsTurnos.filter(t =>
                                                          t.local !== seccao || !TIPOS_SUBST.includes(t.tipo)
                                                        );
                                                        
                                                        // Adicionar novos turnos (normal ou apoio)
                                                        const turnosAdicionar = turnosNovos.map((tn, idx) => {
                                                          if (tn.semHoras) {
                                                            const existente = todosOsTurnos.find(t => t.local === seccao && t.tipo === tn.tipo && !t.entrada);
                                                            return {
                                                              tipo: tn.tipo, local: seccao, entrada: null, saida: null,
                                                              horas: tn.tipo === 'gestao' ? 8.0 : (existente?.horas ?? (tn.tipo === 'reuniao' ? 1.0 : null)),
                                                            };
                                                          }
                                                          // CALCULAR HORAS baseado em entrada e saída
                                                          const horasCalculadas = calcularHoras(tn.entrada, tn.saida);
                                                          const horasNumero = parseFloat(horasCalculadas);
                                                          console.log(`✅ [Vista Semanas] Turno adicionado: ${tn.entrada}-${tn.saida} = ${horasNumero}h`);
                                                          
                                                          // PRESERVAR e_troca do turno anterior se existir
                                                          const turnoAnterior = todosOsTurnos.find(t => t.local === seccao && t.tipo === 'normal');
                                                          const preservarTroca = turnoAnterior?.e_troca || false;
                                                          
                                                          return {
                                                            tipo: tn.tipo || 'normal',
                                                            local: seccao,
                                                            entrada: tn.entrada,
                                                            saida: tn.saida,
                                                            horas: horasNumero,
                                                            e_troca: preservarTroca
                                                          };
                                                        });
                                                        
                                                        return {
                                                          ...c,
                                                          registos_por_dia: {
                                                            ...c.registos_por_dia,
                                                            [dia]: [...turnosParaManter, ...turnosAdicionar]
                                                          }
                                                        };
                                                      }
                                                      return c;
                                                    }));
                                                    
                                                    // Atualizar valor do textarea com formato correto (quebras de linha VERTICAIS)
                                                    const PREFIXOS = {
                                                      'apoio': 'APOIO ',
                                                      'reuniao': 'REUNIÃO ',
                                                      'integracao': 'INTEGRAÇÃO ',
                                                      'gestao': 'GESTÃO ',
                                                    };
                                                    e.target.value = turnosNovos.map(t =>
                                                      t.semHoras ? (PREFIXOS[t.tipo] || '').trim() : `${PREFIXOS[t.tipo] || ''}${t.entrada}-${t.saida}`
                                                    ).join('\n');
                                                  } else {
                                                    // Se não der match, limpar
                                                    e.target.value = '';
                                                  }
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  e.target.focus();
                                                }}
                                              />
                                              
                                              {/* Botão + para adicionar turno - SEMPRE VISÍVEL */}
                                              {!readOnly && (
                                                <button
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    // Abrir menu rápido
                                                    setQuickMenuPosition({
                                                      top: e.currentTarget.getBoundingClientRect().bottom,
                                                      left: e.currentTarget.getBoundingClientRect().left
                                                    });
                                                    setQuickMenuData({
                                                      colabId: colab.colaborador_id,
                                                      dia: dia,
                                                      seccao: seccao
                                                    });
                                                  }}
                                                  className="absolute top-0.5 right-0.5 bg-blue-500 hover:bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-[11px] font-bold shadow-sm hover:shadow-md transition-all z-10"
                                                  title="Adicionar turno rápido"
                                                >
                                                  +
                                                </button>
                                              )}
                                              </div>
                                            </td>
                                          );
                                        };
                                        
                                        return (
                                          <React.Fragment key={`dia-${diaIdx}`}>
                                            {/* CAFÉ */}
                                            {renderCelulaEditavel(turnosCafe, 'Café')}
                                            
                                            {/* LOJA AVELAL */}
                                            {renderCelulaEditavel(turnosAvelal, 'Loja Avelal')}
                                            
                                            {/* LOJA SÁTÃO */}
                                            {renderCelulaEditavel(turnosSatao, 'Loja Sátão')}
                                          </React.Fragment>
                                        );
                                      })}
                                      
                                      {/* COLUNAS DE TOTAIS */}
                                      {(() => {
                                        // Calcular totais APENAS para ESTA SEMANA
                                        let totalHoras = 0;
                                        let totalFeriado = 0;

                                        // Conjuntos para rastrear dias únicos
                                        const diasComFerias = new Set();
                                        const diasComGestao = new Set();
                                        const diasComBaixa = new Set();
                                        const diasComFolgaComp = new Set();

                                        // ITERAR APENAS SOBRE OS DIAS DESTA SEMANA (não todos os dias)
                                        semana.forEach(dia => {
                                          const turnos = colab.registos_por_dia?.[dia] || [];
                                          const ehFeriado = isFeriado(dia);

                                          turnos.forEach(turno => {
                                            // Marcar dias únicos para tipos especiais
                                            if (turno.tipo === 'ferias') diasComFerias.add(dia);
                                            const gestaoDiaInteiro = turno.tipo === 'gestao' && !(turno.entrada && turno.saida);
                                            if (gestaoDiaInteiro) diasComGestao.add(dia);
                                            if (turno.tipo === 'baixa') diasComBaixa.add(dia);
                                            if (turno.tipo === 'folga_compensacao') diasComFolgaComp.add(dia);

                                            if (gestaoDiaInteiro) {
                                              // 8h por dia único (somado abaixo)
                                            } else if (['normal', 'apoio', 'troca', 'reuniao', 'integracao', 'gestao'].includes(turno.tipo) && turno.horas) {
                                              const horas = parseFloat(turno.horas);
                                              if (ehFeriado) {
                                                totalFeriado += horas;  // Apenas rastrear para display
                                              }
                                              totalHoras += horas;  // Feriados contam como horas normais
                                            } else if (turno.tipo === 'reuniao') {
                                              totalHoras += 1;
                                            }
                                          });
                                        });

                                        // Adicionar horas por DIA único (não por turno) - APENAS DESTA SEMANA
                                        // Férias/Gestão/Baixa/Folga Comp.: 8h/dia (regra 13-05-2026)
                                        const horasFerias = diasComFerias.size * 8;
                                        const horasGestao = diasComGestao.size * 8;
                                        const horasBaixa = diasComBaixa.size * 8;
                                        const horasFolgaComp = diasComFolgaComp.size * 8;

                                        totalHoras += horasFerias + horasGestao + horasBaixa + horasFolgaComp;
                                        
                                        return (
                                          <>
                                            {/* Total H - ÚNICA COLUNA NO FINAL */}
                                            <td className="border border-black p-1 text-center bg-blue-50">
                                              <div className="text-sm font-bold text-blue-700">
                                                {formatarHoras(totalHoras.toFixed(2))}
                                              </div>
                                            </td>
                                          </>
                                        );
                                      })()}
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        );
                      });
                    })()}
                    
                    {/* LEGENDA */}
                    <div className="mt-6 p-3 bg-gray-50 rounded border">
                      <div className="text-xs font-semibold mb-2">📌 Como usar:</div>
                      <div className="text-[10px] space-y-1">
                        <div>• <strong>Cada semana é apresentada numa tabela separada</strong> (empilhadas verticalmente)</div>
                        <div>• <strong>Escreva os horários diretamente</strong> na célula</div>
                        <div>• <strong>Formatos aceites:</strong></div>
                        <div className="ml-4">
                          - Simples: <code className="bg-gray-200 px-1 rounded">9-17</code> (9h às 17h)
                        </div>
                        <div className="ml-4">
                          - Com &quot;h&quot;: <code className="bg-gray-200 px-1 rounded">9h-17h</code> ou <code className="bg-gray-200 px-1 rounded">9h30-17h</code>
                        </div>
                        <div className="ml-4">
                          - Completo: <code className="bg-gray-200 px-1 rounded">09:00-17:00</code> ou <code className="bg-gray-200 px-1 rounded">13:30-20:00</code>
                        </div>
                        <div>• <strong>As horas são calculadas automaticamente</strong> (entrada - saída)</div>
                        <div>• <strong>Para apagar:</strong> Apague o texto e clique fora</div>
                        <div>• <strong>3 colunas por dia:</strong> Café, Loja (Avelal), Sátão</div>
                      </div>
                      
                      <div className="text-xs font-semibold mt-3 mb-2">🎨 Legenda de Cores de Fundo:</div>
                      <div className="grid grid-cols-2 md:grid-cols-5 gap-2 text-[10px]">
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-yellow-300 border border-black rounded"></div>
                          <span>🏖️ Folga</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-green-200 border border-black rounded"></div>
                          <span>✈️ Férias</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-red-200 border border-black rounded"></div>
                          <span>❌ Falta</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-purple-200 border border-black rounded"></div>
                          <span>👥 Reunião</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-orange-200 border border-black rounded"></div>
                          <span>📋 Gestão</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-yellow-100 border border-black rounded"></div>
                          <span>🏥 Baixa</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-indigo-100 border border-black rounded"></div>
                          <span>🤝 Apoio</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-red-50 border border-black rounded"></div>
                          <span>Domingo/Feriado</span>
                        </div>
                      </div>
                      
                      <div className="text-xs font-semibold mt-3 mb-2">📋 Colunas (3 por dia):</div>
                      <div className="grid grid-cols-3 gap-2 text-[10px]">
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-orange-100 border border-black rounded"></div>
                          <span>Café</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-blue-100 border border-black rounded"></div>
                          <span>Loja Avelal</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 bg-green-100 border border-black rounded"></div>
                          <span>Loja Sátão</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}

              {/* MODO CLÁSSICO - Layout Original */}
              {!modoExcel && days.length > 0 && (
                <Card>
                  <CardContent className="pt-6">
                    {/* Wrapper com scroll horizontal e vertical */}
                    <div className="overflow-auto max-h-[70vh]" style={{position: 'relative'}}>
                      {/* Tabela única com header e body */}
                      <table className="text-xs border border-gray-400" style={{borderSpacing: 0, borderCollapse: 'collapse'}}>
                        <thead>
                          {/* Linha 1: Número das Semanas */}
                          <tr className="border-b-2 border-black bg-gray-100">
                            <th className="text-left p-1 text-xs border-r border-black" style={{position: 'sticky', left: 0, top: 0, backgroundColor: '#f3f4f6', zIndex: 11, width: '150px', minWidth: '150px', maxWidth: '150px'}}>
                              
                            </th>
                            {(() => {
                              // Usar função helper para semanas de calendário
                              const semanas = agruparPorSemanasCalendario(days);
                              
                              return semanas.map((semana, idx) => {
                                // Número da semana (baseado no primeiro dia)
                                const primeiraData = new Date(semana[0] + 'T00:00:00');
                                const numSemana = Math.ceil((primeiraData.getDate()) / 7);
                                
                                return (
                                  <th 
                                    key={idx}
                                    colSpan={semana.length * 3}
                                    className="text-center p-1 border-r border-black bg-gray-100 font-bold text-sm"
                                    style={{position: 'sticky', top: 0, backgroundColor: '#f3f4f6', zIndex: 10}}
                                  >
                                    {numSemana}
                                  </th>
                                );
                              });
                            })()}
                            <th rowSpan="3" className="text-center p-1 text-xs border-l-2 border-black bg-blue-100" style={{position: 'sticky', top: 0, zIndex: 10, minWidth: '80px'}}>Total H</th>
                          </tr>
                          
                          {/* Linha 2: Dias da Semana */}
                          <tr className="border-b-2 border-black bg-gray-100">
                            <th className="text-left p-2 border-r border-black" style={{position: 'sticky', left: 0, top: '40px', backgroundColor: '#f3f4f6', zIndex: 11, width: '200px', minWidth: '200px', maxWidth: '200px'}}>
                              
                            </th>
                            {(() => {
                              // Usar função helper para semanas de calendário
                              const semanas = agruparPorSemanasCalendario(days);
                              
                              return semanas.map((semana, semanaIdx) => 
                                semana.map(day => {
                                  const date = new Date(day + 'T00:00:00');
                                  const nomeDia = date.toLocaleDateString('pt-PT', { weekday: 'long' }).toUpperCase();
                                  const numeroDia = date.getDate(); // Número do dia do mês (1-31)
                                  const isFeriadoDay = isFeriado(day);
                                  
                                  return (
                                    <th 
                                      key={day}
                                      colSpan={3}
                                      className={`text-center p-1 border-r border-black font-bold ${
                                        isFeriadoDay ? 'bg-red-200' : 'bg-gray-50'
                                      }`}
                                      style={{position: 'sticky', top: '40px', backgroundColor: isFeriadoDay ? '#fecaca' : '#f9fafb', zIndex: 10}}
                                    >
                                      <div className="flex flex-col items-center">
                                        <div className="text-xs">{nomeDia}{isFeriadoDay && ' 🎉'}</div>
                                        <div className="text-lg font-bold text-blue-600">{numeroDia}</div>
                                      </div>
                                    </th>
                                  );
                                })
                              );
                            })()}
                          </tr>
                          
                          {/* Linha 3: Café | Loja Avelal | Loja Sátão */}
                          <tr className="border-b-2 border-black bg-gray-100">
                            <th className="text-left p-2 border-r border-black font-bold" style={{position: 'sticky', left: 0, top: '100px', backgroundColor: '#f3f4f6', zIndex: 11, width: '200px', minWidth: '200px', maxWidth: '200px'}}>
                              Colaborador
                            </th>
                            {(() => {
                              // Usar função helper para semanas de calendário
                              const semanas = agruparPorSemanasCalendario(days);
                              
                              return semanas.map((semana, semanaIdx) => 
                                semana.map(day => (
                                  <React.Fragment key={day}>
                                    <th className="text-center p-2 border-r border-gray-400 text-xs font-bold bg-orange-100" style={{position: 'sticky', top: '100px', backgroundColor: '#fed7aa', zIndex: 10, width: '120px'}}>Café</th>
                                    <th className="text-center p-2 border-r border-gray-400 text-xs font-bold bg-blue-100" style={{position: 'sticky', top: '100px', backgroundColor: '#dbeafe', zIndex: 10, width: '120px'}}>Loja Avelal</th>
                                    <th className="text-center p-2 border-r border-black text-xs font-bold bg-green-100" style={{position: 'sticky', top: '100px', backgroundColor: '#dcfce7', zIndex: 10, width: '120px'}}>Loja Sátão</th>
                                  </React.Fragment>
                                ))
                              );
                            })()}
                          </tr>
                        </thead>
                        <tbody>
                            {/* Novo layout: todos os colaboradores juntos, não separados por secção */}
                            {colaboradoresHorarios.map(colab => {
                              // CÁLCULO CORRETO: Verificar se a DATA é feriado, não o tipo do registo
                              const registosPorDia = colab.registos_por_dia || {};
                              let totalHorasNormais = 0;
                              let totalHorasFeriado = 0;
                              let totalHorasFerias = 0;
                              let totalHorasReunioes = 0;
                              let totalHorasBaixa = 0;
                              let totalHorasFolgaComp = 0;
                              const _diasComFolgaComp = new Set();
                              const _diasGestaoInteiro = new Set();

                              // Iterar por cada dia
                              Object.keys(registosPorDia).forEach(dia => {
                                const turnos = registosPorDia[dia];
                                const ehFeriado = isFeriado(dia);

                                turnos.forEach(turno => {
                                  // DEBUG DETALHADO
                                  console.log(`🔍 [${colab.colaborador_nome}] Dia ${dia}:`, {
                                    tipo: turno.tipo,
                                    entrada: turno.entrada,
                                    saida: turno.saida,
                                    horas: turno.horas,
                                    horasType: typeof turno.horas,
                                    local: turno.local
                                  });
                                  
                                  if (turno.tipo === 'ferias') {
                                    totalHorasFerias += 8;
                                    console.log(`  ✅ Férias: +8h (total: ${totalHorasFerias.toFixed(2)}h)`);
                                  } else if (turno.tipo === 'folga_compensacao') {
                                    _diasComFolgaComp.add(dia);
                                  } else if (turno.tipo === 'baixa') {
                                    totalHorasBaixa += 8;
                                    console.log(`  ✅ Baixa: +8h (total: ${totalHorasBaixa.toFixed(2)}h)`);
                                  } else if (turno.tipo === 'reuniao') {
                                    // Reunião: somar horas reais se definidas, senão default 1h
                                    const h = turno.horas ? parseFloat(turno.horas) : 1;
                                    totalHorasReunioes += h;
                                    console.log(`  ✅ Reunião: +${h}h (total: ${totalHorasReunioes}h)`);
                                  } else if (turno.tipo === 'gestao') {
                                    // Gestão: horas reais se tem entrada/saida, senão 8h por dia único
                                    if (!(turno.entrada && turno.saida)) { _diasGestaoInteiro.add(dia); return; }
                                    const h = parseFloat(turno.horas) || 0;
                                    if (ehFeriado) totalHorasFeriado += h; else totalHorasNormais += h;
                                    console.log(`  ✅ Gestão: +${h}h (total: ${totalHorasNormais}h)`);
                                  } else if (['normal', 'troca', 'apoio', 'integracao'].includes(turno.tipo) && turno.horas) {
                                    const horas = parseFloat(turno.horas);
                                    if (ehFeriado) {
                                      totalHorasFeriado += horas;
                                      console.log(`  ✅ ${turno.tipo} (feriado): +${horas}h (total feriado: ${totalHorasFeriado}h)`);
                                    } else {
                                      totalHorasNormais += horas;
                                      console.log(`  ✅ ${turno.tipo} (normal): +${horas}h (total normal: ${totalHorasNormais}h)`);
                                    }
                                  } else if (turno.tipo === 'baixa') {
                                    totalHorasNormais += 8;
                                    console.log(`  ✅ ${turno.tipo}: +8h (total: ${totalHorasNormais}h)`);
                                  } else {
                                    console.log(`  ⚠️ Turno NÃO contabilizado! Razão:`, {
                                      temTipo: !!turno.tipo,
                                      tipoValido: ['normal', 'troca', 'apoio', 'reuniao', 'integracao', 'gestao'].includes(turno.tipo),
                                      temHoras: !!turno.horas,
                                      valorHoras: turno.horas
                                    });
                                  }
                                });
                              });
                              
                              // REGRA 2026: Feriados contam ×1 a partir de 2026
                              const anoCalcEdit = days.length > 0 ? new Date(days[0] + 'T00:00:00').getFullYear() : new Date().getFullYear();
                              // Feriados contam como hora normal (×1). Folga Compensação = 8h por dia.
                              totalHorasFolgaComp = _diasComFolgaComp.size * 8;
                              totalHorasNormais += _diasGestaoInteiro.size * 8;
                              const totalHoras = totalHorasNormais + totalHorasFeriado + totalHorasFerias + totalHorasReunioes + totalHorasFolgaComp;
                              
                              // LOG RESUMO FINAL
                              console.log(`📊 [${colab.colaborador_nome}] RESUMO CÁLCULO:`, {
                                totalHorasNormais: totalHorasNormais.toFixed(1),
                                totalHorasFeriado: totalHorasFeriado.toFixed(1),
                                totalHorasFerias: totalHorasFerias.toFixed(1),
                                totalHorasReunioes: totalHorasReunioes.toFixed(1),
                                totalHorasFinal: totalHoras.toFixed(1),
                                horasEsperadas,
                                bancoAnterior: (colab.banco_horas_anterior || 0).toFixed(1)
                              });
                              
                              const bancoAnterior = colab.banco_horas_anterior || 0;
                              const bancoDesteMes = totalHoras - horasEsperadas;
                              const bancoCalculado = bancoAnterior + bancoDesteMes;
                              
                              // Reconstruir todosRegistos para contagens
                              const todosRegistos = Object.values(registosPorDia).flat();
                              
                              const diasFerias = todosRegistos.filter(r => r.tipo === 'ferias').length;
                              const diasFalta = todosRegistos.filter(r => r.tipo === 'falta').length;
                              const diasFolgaNormal = todosRegistos.filter(r => r.tipo === 'folga').length;
                              const diasFolgaComp = todosRegistos.filter(r => r.tipo === 'folga_compensacao').length;
                              const diasFolga = diasFolgaNormal + diasFolgaComp;
                              const diasBaixa = todosRegistos.filter(r => r.tipo === 'baixa').length;
                              const diasGestao = todosRegistos.filter(r => r.tipo === 'gestao').length;
                              const turnosApoio = todosRegistos.filter(r => r.tipo === 'apoio').length;
                              
                              const totalManhas = todosRegistos.filter(r => {
                                if (!r.entrada || !r.horas) return false;
                                const [hora] = r.entrada.split(':').map(Number);
                                return hora >= 5 && hora < 12 && parseFloat(r.horas) >= 2;
                              }).length;
                              
                              const totalTardes = todosRegistos.filter(r => {
                                if (!r.entrada || !r.horas) return false;
                                const [hora] = r.entrada.split(':').map(Number);
                                return hora >= 12 && hora < 20 && parseFloat(r.horas) >= 2;
                              }).length;
                              
                              // Debug log
                              if (colab.colaborador_nome === 'Administrador' && totalHoras > 0) {
                                console.log(`📊 Cálculo Banco - ${colab.colaborador_nome}:`);
                                console.log(`  - Horas normais: ${totalHorasNormais.toFixed(1)}h`);
                                console.log(`  - Horas feriado: ${totalHorasFeriado.toFixed(1)}h (hora normal)`);
                                console.log(`  - Dias férias: ${diasFerias} (${totalHorasFerias.toFixed(1)}h)`);
                                console.log(`  - Total horas: ${totalHoras.toFixed(1)}h`);
                                console.log(`  - Total para banco: ${totalHoras.toFixed(1)}h`);
                                console.log(`  - Horas esperadas: ${horasEsperadas}h`);
                                console.log(`  - Banco anterior: ${(colab.banco_horas_anterior || 0).toFixed(1)}h`);
                                console.log(`  - Banco calculado: ${bancoCalculado.toFixed(1)}h`);
                              }
                              
                              return (
                                <tr key={colab.colaborador_id} className="border-b">
                                  <td className="p-1 border-r" style={{position: 'sticky', left: 0, backgroundColor: 'white', zIndex: 5, boxShadow: '2px 0 4px rgba(0,0,0,0.1)', width: '150px', minWidth: '150px', maxWidth: '150px'}}>
                                    <div className="flex items-center justify-between gap-1">
                                      <div className="flex-1">
                                        <div className="font-medium text-xs">
                                          <span>{colab.colaborador_nome}</span>
                                        </div>
                                      </div>
                                      <div className="flex flex-col gap-1">
                                        <button
                                          onClick={() => moverColaboradorCima(colab.colaborador_id, colab.seccao)}
                                          className="p-0.5 hover:bg-primary/10 rounded text-muted-foreground hover:text-primary"
                                          title="Mover para cima"
                                        >
                                          <ChevronUp className="h-3 w-3" />
                                        </button>
                                        <button
                                          onClick={() => moverColaboradorBaixo(colab.colaborador_id, colab.seccao)}
                                          className="p-0.5 hover:bg-primary/10 rounded text-muted-foreground hover:text-primary"
                                          title="Mover para baixo"
                                        >
                                          <ChevronDown className="h-3 w-3" />
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                  {(() => {
                                    // Simplesmente iterar sobre todos os dias (sem agrupamento por semanas)
                                    // O agrupamento visual já existe no cabeçalho da tabela
                                    return days.map(day => {
                                      const isFeriadoDay = isFeriado(day);
                                      const isWeekendDay = isWeekend(day);
                                      
                                      // Para cada dia, mostrar 3 células: Café, Loja Avelal, Loja Sátão
                                      return (
                                        <React.Fragment key={day}>
                                          {SECCOES.map((seccao, seccaoIdx) => {
                                              // Pegar turnos deste dia que são desta secção
                                              const turnosSeccao = (colab.registos_por_dia[day] || []).filter(t => 
                                                t.local === seccao || (!t.local && seccao === colab.seccao)
                                              );
                                              
                                              // Cores de fundo por seção (leve)
                                              const coresPorSeccao = {
                                                'Café': 'bg-orange-50',
                                                'Loja Avelal': 'bg-blue-50', 
                                                'Loja Sátão': 'bg-green-50'
                                              };
                                              
                                              // Feriado e fim de semana têm prioridade
                                              let bgColor = isFeriadoDay ? 'bg-red-100' : 
                                                            isWeekendDay ? 'bg-amber-50' : 
                                                            coresPorSeccao[seccao] || 'bg-white';
                                              
                                              const borderClass = seccaoIdx === 2 ? 'border-r-2 border-black' : 'border-r border-gray-300';
                                              
                                              return (
                                                <td 
                                                  key={`${day}-${seccao}`}
                                                  className={`p-1 ${bgColor} ${borderClass} align-top`}
                                                  style={{width: '80px', fontSize: '11px'}}
                                                >
                                                  {/* RENDERIZAR TODOS OS TURNOS */}
                                                  {turnosSeccao.map((turno, turnoIdx) => {
                                                    // Cores por tipo de turno (MAIS VIVAS)
                                                    const corPorTipo = {
                                                      'normal': 'bg-blue-200 border-blue-400 text-blue-900',
                                                      'folga': 'bg-gray-300 border-gray-500 text-gray-800',
                                                      'folga_compensacao': 'bg-gray-300 border-gray-500 text-gray-800',
                                                      'ferias': 'bg-green-200 border-green-400 text-green-900',
                                                      'falta': 'bg-red-200 border-red-400 text-red-900',
                                                      'gestao': 'bg-orange-200 border-orange-400 text-orange-900',
                                                      'reuniao': 'bg-purple-200 border-purple-400 text-purple-900',
                                                      'integracao': 'bg-teal-200 border-teal-400 text-teal-900',
                                                      'apoio': 'bg-indigo-200 border-indigo-400 text-indigo-900',
                                                      'baixa': 'bg-yellow-200 border-yellow-400 text-yellow-900',
                                                      'troca': 'bg-gradient-to-r from-orange-300 to-red-300 border-4 border-orange-600 text-orange-900',
                                                    };
                                                    const corTurno = corPorTipo[turno.tipo] || 'bg-gray-100 border-gray-300';
                                                    const isTroca = turno.e_troca === true;
                                                    
                                                    return (
                                                      <div key={turnoIdx} className="mb-1 relative">
                                                        {/* Badge de TROCA */}
                                                        {isTroca && (
                                                          <div className="absolute top-0 right-0 z-30">
                                                            <div className="bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded-bl shadow-lg">
                                                              🔄 TROCA
                                                            </div>
                                                          </div>
                                                        )}
                                                        <div className={`p-0.5 rounded border ${isTroca ? 'border-2 border-orange-500 ring-1 ring-orange-300' : ''} ${corTurno}`}>
                                                          <div className="text-[10px] font-bold">{turno.tipo?.toUpperCase()}</div>
                                                          {turno.entrada && turno.saida && (() => {
                                                            // SEMPRE calcular horas de entrada/saída
                                                            const [h1, m1] = turno.entrada.split(':').map(Number);
                                                            const [h2, m2] = turno.saida.split(':').map(Number);
                                                            const minutos = (h2 * 60 + m2) - (h1 * 60 + m1);
                                                            const horas = minutos / 60;
                                                            
                                                            // Converter para formato Xh Ym
                                                            const h = Math.floor(horas);
                                                            const m = Math.round((horas - h) * 60);
                                                            const horasFormatadas = m === 0 ? `${h}h` : `${h}h${m}m`;
                                                            
                                                            return (
                                                              <div className="text-[10px]">
                                                                {turno.tipo === 'apoio' && 'APOIO '}{turno.tipo === 'reuniao' && 'REUNIÃO '}{turno.tipo === 'integracao' && 'INTEGRAÇÃO '}{turno.tipo === 'gestao' && 'GESTÃO '}{turno.entrada}-{turno.saida} ({horasFormatadas})
                                                              </div>
                                                            );
                                                          })()}
                                                          <button
                                                            onClick={() => {
                                                              if (window.confirm('Apagar este turno?')) {
                                                                setColaboradoresHorarios(prev => prev.map(c => {
                                                                  if (String(c.colaborador_id) !== String(colab.colaborador_id)) return c;
                                                                  const registosAtualizados = { ...c.registos_por_dia };
                                                                  if (registosAtualizados[day]) {
                                                                    // Remover este turno específico do array
                                                                    const indexGlobal = registosAtualizados[day].indexOf(turno);
                                                                    if (indexGlobal !== -1) {
                                                                      registosAtualizados[day].splice(indexGlobal, 1);
                                                                    }
                                                                    
                                                                    if (registosAtualizados[day].length === 0) {
                                                                      delete registosAtualizados[day];
                                                                    }
                                                                  }
                                                                  return { ...c, registos_por_dia: registosAtualizados };
                                                                }));
                                                              }
                                                            }}
                                                            className="text-[10px] text-red-600 hover:text-red-800"
                                                          >
                                                            ✕ Apagar
                                                          </button>
                                                        </div>
                                                      </div>
                                                  );
                                                  })}
                                                  
                                                  {/* BOTÃO + SEMPRE VISÍVEL */}
                                                  <button
                                                    onClick={() => {
                                                      setModalTurno({ colabId: colab.colaborador_id, day, seccao });
                                                      setIsTrocaModal(false); // Resetar checkbox ao abrir modal
                                                    }}
                                                    className="w-full text-xs bg-blue-500 text-white rounded py-1 hover:bg-blue-600 mt-1"
                                                  >
                                                    + Turno
                                                  </button>
                                                  
                                                  {/* BOTÃO COPIAR DIA - Copia turnos desta célula para o dia seguinte */}
                                                  {turnosSeccao.length > 0 && (() => {
                                                    const dayIndex = days.indexOf(day);
                                                    const temDiaSeguinte = dayIndex < days.length - 1;
                                                    
                                                    if (!temDiaSeguinte) return null;
                                                    
                                                    return (
                                                      <button
                                                        onClick={() => {
                                                          const diaSeguinte = days[dayIndex + 1];
                                                          setColaboradoresHorarios(prev => prev.map(c => {
                                                            if (String(c.colaborador_id) !== String(colab.colaborador_id)) return c;
                                                            
                                                            const registosAtualizados = JSON.parse(JSON.stringify(c.registos_por_dia || {}));
                                                            if (!registosAtualizados[diaSeguinte]) registosAtualizados[diaSeguinte] = [];
                                                            
                                                            // Copiar apenas turnos desta seção
                                                            const turnosParaCopiar = turnosSeccao.map(t => ({ ...t }));
                                                            turnosParaCopiar.forEach(turno => {
                                                              registosAtualizados[diaSeguinte].push(turno);
                                                            });
                                                            
                                                            console.log(`📋 Copiado ${turnosParaCopiar.length} turno(s) de ${day} para ${diaSeguinte} (${seccao})`);
                                                            return { ...c, registos_por_dia: registosAtualizados };
                                                          }));
                                                        }}
                                                        className="w-full text-[10px] bg-green-500 text-white rounded py-0.5 hover:bg-green-600 mt-1"
                                                        title="Copiar turnos deste dia para o dia seguinte"
                                                      >
                                                        📋 Copiar →
                                                      </button>
                                                    );
                                                  })()}
                                                </td>
                                              );
                                            })}
                                          </React.Fragment>
                                        );
                                    });
                                  })()}
                                  {/* COLUNAS DE TOTAIS - SEMPRE VISÍVEIS NO RESUMO NO TOPO */}
                                  <td className="p-2 text-center font-bold bg-blue-50 border-l-2 border-black">
                                    <div className="text-sm font-bold text-primary">{formatarHoras(totalHoras.toFixed(2))}</div>
                                    <div className="text-[9px] text-muted-foreground mt-1 space-y-0.5">
                                      {totalHorasNormais > 0 && (
                                        <div>Normal: {formatarHoras(totalHorasNormais.toFixed(2))}</div>
                                      )}
                                      {diasFerias > 0 && (
                                        <div className="text-green-600">
                                          Férias: {diasFerias}d ({formatarHoras(totalHorasFerias.toFixed(2))})
                                        </div>
                                      )}
                                      {totalHorasReunioes > 0 && (
                                        <div className="text-purple-600">
                                          Reuniões: {formatarHoras(totalHorasReunioes.toFixed(2))}
                                        </div>
                                      )}
                                      {totalHorasFeriado > 0 && (
                                        <div className="text-red-600">
                                          🎉 Feriado: {formatarHoras(totalHorasFeriado.toFixed(2))} (hora normal)
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="p-2 text-center bg-green-50">{diasFerias}</td>
                                  <td className="p-2 text-center bg-red-50">{diasFalta}</td>
                                  <td className="p-2 text-center bg-gray-50">{diasFolga}{diasFolgaComp > 0 ? ` (${diasFolgaComp}FC)` : ''}</td>
                                  {isAdmin && (
                                    <>
                                      <td className="p-2 text-center bg-cyan-50">{totalManhas}</td>
                                      <td className="p-2 text-center bg-pink-50">{totalTardes}</td>
                                    </>
                                  )}
                                  <td className="p-2 text-center bg-orange-50">
                                    <input
                                      type="text"
                                      key={`banco-completo-${colab.colaborador_id}-${colab.banco_horas_anterior}`}
                                      defaultValue={(() => {
                                        const valor = colab.banco_horas_anterior || 0;
                                        const horas = Math.floor(Math.abs(valor));
                                        const minutos = Math.round((Math.abs(valor) % 1) * 60);
                                        const sinal = valor < 0 ? '-' : '';
                                        return minutos > 0 ? `${sinal}${horas}h${minutos}m` : `${sinal}${horas}h`;
                                      })()}
                                      onBlur={(e) => {
                                        const valor = e.target.value.trim();
                                        if (!valor) {
                                          setColaboradoresHorarios(prev => prev.map(c =>
                                            c.colaborador_id === colab.colaborador_id
                                              ? { ...c, banco_horas_anterior: 0, banco_horas_anterior_manual: true }
                                              : c
                                          ));
                                          e.target.value = '0h';
                                          return;
                                        }
                                        
                                        // PARSER MAIS PERMISSIVO
                                        let novoValor = null;
                                        let match;
                                        
                                        // Formato 1: -55h30m ou 55h30m
                                        if (match = valor.match(/^(-?)(\d+)h(\d+)m?$/)) {
                                          const sinal = match[1] === '-' ? -1 : 1;
                                          const horas = parseInt(match[2]) || 0;
                                          const minutos = parseInt(match[3]) || 0;
                                          novoValor = sinal * (horas + minutos / 60);
                                        }
                                        // Formato 2: -55h ou 55h
                                        else if (match = valor.match(/^(-?)(\d+)h$/)) {
                                          const sinal = match[1] === '-' ? -1 : 1;
                                          const horas = parseInt(match[2]) || 0;
                                          novoValor = sinal * horas;
                                        }
                                        // Formato 3: -55 ou 55
                                        else if (match = valor.match(/^(-?\d+)$/)) {
                                          novoValor = parseFloat(match[1]);
                                        }
                                        
                                        if (novoValor !== null) {
                                          console.log(`✏️ [Vista Completa] Banco Ant. editado: ${colab.colaborador_nome} = ${novoValor}h (input: "${valor}")`);
                                          
                                          setColaboradoresHorarios(prev => prev.map(c =>
                                            c.colaborador_id === colab.colaborador_id
                                              ? { ...c, banco_horas_anterior: novoValor, banco_horas_anterior_manual: true }
                                              : c
                                          ));
                                          
                                          // Normalizar
                                          const horasAbs = Math.floor(Math.abs(novoValor));
                                          const minutosAbs = Math.round((Math.abs(novoValor) % 1) * 60);
                                          const sinalFinal = novoValor < 0 ? '-' : '';
                                          e.target.value = minutosAbs > 0 ? `${sinalFinal}${horasAbs}h${minutosAbs}m` : `${sinalFinal}${horasAbs}h`;
                                        } else {
                                          // Formato inválido: Restaurar SILENCIOSAMENTE
                                          console.warn(`⚠️ Formato inválido ignorado: "${valor}". Restaurando valor anterior.`);
                                          const valorAtual = colab.banco_horas_anterior || 0;
                                          const horas = Math.floor(Math.abs(valorAtual));
                                          const minutos = Math.round((Math.abs(valorAtual) % 1) * 60);
                                          const sinal = valorAtual < 0 ? '-' : '';
                                          e.target.value = minutos > 0 ? `${sinal}${horas}h${minutos}m` : `${sinal}${horas}h`;
                                          // Feedback visual temporário
                                          e.target.style.borderColor = 'red';
                                          e.target.style.backgroundColor = '#fee';
                                          setTimeout(() => {
                                            e.target.style.borderColor = '';
                                            e.target.style.backgroundColor = '';
                                          }, 1500);
                                        }
                                      }}
                                      className="w-full max-w-[110px] px-2 py-1 text-sm text-center border-2 border-orange-400 rounded bg-white hover:border-orange-600 focus:border-orange-700 focus:ring-2 focus:ring-orange-300 font-semibold text-orange-700"
                                      title="✏️ Digite: -55h30m ou -55h ou -55 (pressione Enter ou clique fora)"
                                      placeholder="0h"
                                    />
                                  </td>
                                  <td className="p-2 text-center bg-yellow-50">
                                    <div 
                                      className={`text-xs font-bold ${bancoCalculado >= 0 ? 'text-green-600' : 'text-red-600'}`}
                                      title={`Horas normais: ${formatarHoras(totalHorasNormais)} | Horas feriado: ${formatarHoras(totalHorasFeriado)} (hora normal) | Esperadas: ${horasEsperadas}h | Banco anterior: ${formatarHoras(colab.banco_horas_anterior || 0)}`}
                                    >
                                      {formatarHoras(bancoCalculado)}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                      </table>
                    </div>
                  </CardContent>
                </Card>
              )}
            </div>

          </div>
        </div>
      )}

          </>

      {/* Menu Rápido Flutuante - GLOBAL para todos os modos */}
      {quickMenuPosition && quickMenuData && (
        <>
          {/* Overlay para fechar ao clicar fora */}
          <div 
            className="fixed inset-0 z-[60] bg-transparent"
            onClick={() => {
              setQuickMenuPosition(null);
              setQuickMenuData(null);
            }}
            style={{ cursor: 'default' }}
          />
          
          {/* Menu */}
          <div 
            className="fixed z-[70] bg-white dark:bg-gray-800 rounded-lg shadow-2xl border-2 border-blue-500 p-3 min-w-[220px] max-h-[80vh] overflow-y-auto"
            style={{
              top: Math.min(Math.max(8, quickMenuPosition.top), window.innerHeight - 480) + 'px',
              left: Math.min(Math.max(8, quickMenuPosition.left), window.innerWidth - 260) + 'px',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-xs font-bold mb-2 text-blue-600 dark:text-blue-400 border-b pb-2">
              ⚡ Selecione o tipo de turno:
            </div>
            
            {/* Checkbox Troca - APLICAR DIRETAMENTE */}
            <div className="mb-2 p-2 bg-orange-50 border border-orange-300 rounded">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isTrocaQuickMenu}
                  onChange={(e) => {
                    const marcado = e.target.checked;
                    setIsTrocaQuickMenu(marcado);
                    
                    // APLICAR IMEDIATAMENTE ao turno existente
                    if (quickMenuData) {
                      const { colabId, dia, seccao } = quickMenuData;
                      setColaboradoresHorarios(prev => prev.map(c => {
                        if (String(c.colaborador_id) !== String(colabId)) return c;
                        
                        const registosAtualizados = { ...c.registos_por_dia };
                        if (registosAtualizados[dia]) {
                          // Atualizar TODOS os turnos desta secção
                          registosAtualizados[dia] = registosAtualizados[dia].map(t => {
                            if (t.local === seccao && t.tipo === 'normal') {
                              return { ...t, e_troca: marcado };
                            }
                            return t;
                          });
                        }
                        
                        return { ...c, registos_por_dia: registosAtualizados };
                      }));
                      
                      console.log('🔄 Troca ' + (marcado ? 'MARCADA' : 'DESMARCADA'));
                    }
                  }}
                  className="w-4 h-4 cursor-pointer"
                />
                <span className="text-xs font-medium text-orange-900">
                  Troca
                </span>
              </label>
            </div>
            
            <div className="space-y-1">
              {TEMPLATES_TURNOS.map(template => {
                // Separador visual
                if (template.tipo === 'separator') {
                  return (
                    <div key={template.id} className="border-t border-gray-200 my-2" />
                  );
                }
                
                return (
                  <button
                    key={template.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      aplicarTemplate(template);
                    }}
                    className="w-full text-left px-3 py-1.5 text-sm rounded hover:bg-blue-50 dark:hover:bg-blue-900 flex items-center justify-between group transition-all"
                  >
                    <span className="font-medium">{template.nome}</span>
                  </button>
                );
              })}
              
              {/* Horário Personalizado */}
              <div className="border-t border-gray-200 my-2" />
              <div className="px-2 py-2 bg-gray-50 rounded">
                <div className="text-xs font-semibold text-gray-600 mb-2">⏰ Horário Personalizado:</div>
                <div className="flex items-center gap-2">
                  <input
                    type="time"
                    id="quick-entrada"
                    className="border rounded px-2 py-1 text-sm w-24"
                    defaultValue="09:00"
                    onClick={(e) => e.stopPropagation()}
                  />
                  <span className="text-gray-500">-</span>
                  <input
                    type="time"
                    id="quick-saida"
                    className="border rounded px-2 py-1 text-sm w-24"
                    defaultValue="18:00"
                    onClick={(e) => e.stopPropagation()}
                  />
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      const entrada = document.getElementById('quick-entrada')?.value || '09:00';
                      const saida = document.getElementById('quick-saida')?.value || '18:00';
                      aplicarTemplate({
                        id: 'custom',
                        tipo: 'normal',
                        entrada: entrada,
                        saida: saida
                      });
                    }}
                    className="px-3 py-1 bg-blue-500 text-white text-sm rounded hover:bg-blue-600 transition-colors"
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-2 pt-2 border-t text-[10px] text-muted-foreground text-center">
              Clique fora para fechar
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default HorarioVistaAtual;
